import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.code}>404</h1>
      <p style={styles.message}>The page you're looking for doesn't exist.</p>
      <Link to="/" style={styles.link}>
        Go back to homepage
      </Link>
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center",
    padding: "4rem",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  code: {
    fontSize: "6rem",
    margin: "0",
    color: "#333",
  },
  message: {
    fontSize: "1.25rem",
    marginBottom: "2rem",
    color: "#666",
  },
  link: {
    fontSize: "1rem",
    textDecoration: "none",
    color: "#007bff",
    border: "1px solid #007bff",
    padding: "0.5rem 1rem",
    borderRadius: "4px",
  },
};

export default NotFound;
